'use strict';

var _chainedFunction = require('./chained-function');

var _chainedFunction2 = _interopRequireDefault(_chainedFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _chainedFunction2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/chained-function/lib/index.js
// module id = 2487
// module chunks = 0